import React from 'react';

const Footer = () => (
  <footer style={styles.footer}>
    <div>
      &copy; {new Date().getFullYear()} Jaca. All rights reserved.
    </div>
    <div style={{ marginTop: '8px' }}>
      <a href="/about" style={styles.footerLink}>About Us</a>
      {' | '}
       <a href="/help" style={styles.footerLink}>Help</a>
      {' | '}
      {localStorage.getItem('user') && JSON.parse(localStorage.getItem('user')).id ? (
        <a href="/contactus" style={styles.footerLink}>Contact Us</a>
      ) : null}
    </div>
  </footer>
);

const styles = {
  footer: {
    marginTop: '48px',
    padding: '18px 0',
    textAlign: 'center',
    color: '#888',
    fontSize: '1rem',
    background: '#f5f6fa',
    borderRadius: '8px',
    boxShadow: '0 1px 4px rgba(0,0,0,0.04)',
    width: '100%',
  },
  footerLink: {
    color: '#4078c0',
    textDecoration: 'underline',
    margin: '0 8px',
    fontWeight: 'bold',
    fontSize: '1rem',
  },
};

export default Footer;